import * as actions from "state/action-types";

export const setSelectedLocations = (selected = []) => ({
  type: actions.SET_SELECTED_LOCATIONS_FILTER,
  payload: {
    selected,
  },
});

export const setLocationsFilterOptions = (options = []) => ({
  type: actions.SET_LOCATIONS_FILTER_OPTIONS,
  payload: {
    options,
  },
});
